import { useMemo } from "react";

import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { useQuery } from "@tanstack/react-query";

import { initUseQuery } from "simplydo/core/query";
import SearchParams from "simplydo/core/searchParams";
import { ButtonLink } from "simplydo/react/ui/button";
import { Container } from "simplydo/react/ui/container";
import { Divider } from "simplydo/react/ui/divider";
import { H1 } from "simplydo/react/ui/header";
import { Loader } from "simplydo/react/ui/loader";
import { Message } from "simplydo/react/ui/message";

import api from "api";
import { useAppSelector } from "store";

import { TokenInviteCard } from "components/lib/Invitations/InviteCard";

export const Invitation = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const user = useAppSelector((state) => state.user);
  const params = useMemo(
    () => new SearchParams(location.search),
    [location.search],
  );

  const token = useMemo(() => params.get("invite_token"), [params]);
  const invitationQuery = useQuery(
    initUseQuery(api.invitations.findByToken, [token!], { isEnabled: !!token }),
  );
  const invitation = invitationQuery.data?.invitation;

  const invitationEmailParam = useMemo(() => {
    if (invitation?.invitationType === "email") {
      return `&email=${encodeURIComponent(invitation.invitee)}`;
    }
    return "";
  }, [invitation]);

  return (
    <div>
      {(!token || !invitation) && (
        <>
          <H1>Invitations</H1>
          <Divider />
        </>
      )}
      <Container style={{ paddingBottom: 5 }}>
        {token && invitationQuery.isLoading ? (
          <Loader>Loading</Loader>
        ) : token && invitation ? (
          <div>
            <div>
              <Container style={{ paddingBottom: 5 }}>
                {invitationQuery.isLoading ? (
                  <Loader>Loading</Loader>
                ) : (
                  <TokenInviteCard invitation={invitation} />
                )}
              </Container>
            </div>
            {user ? null : (
              <>
                <Message style={{ marginTop: 0 }} color="blue">
                  {t("invitation.loginToAccept")}
                </Message>
                <ButtonLink
                  style={{ float: "right" }}
                  color="primary"
                  to={`/login?then=${encodeURIComponent(`/invitations?invite_token=${token}`)}${invitationEmailParam}`}
                >
                  {t("entry.login.loginOrSignUp")}
                </ButtonLink>
              </>
            )}
          </div>
        ) : (
          <div>
            {token ? (
              <Message color="red">
                You followed a link to an invitation that has expired or was
                already accepted. If you think this is a mistake or if you need
                help, please contact the person who sent you the invitation.
              </Message>
            ) : null}
            {user ? (
              <ButtonLink style={{ float: "right" }} color="primary" to={`/`}>
                {t("generic.backToApplication")}
              </ButtonLink>
            ) : (
              <>
                <Message color="blue">
                  Log in to view your account or sign up below.
                </Message>
                <ButtonLink
                  style={{ float: "right" }}
                  color="primary"
                  to={`/login`}
                >
                  {t("entry.login.loginOrSignUp")}
                </ButtonLink>
              </>
            )}
          </div>
        )}
      </Container>
    </div>
  );
};
